import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import SimpleReactLightbox from "simple-react-lightbox";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from './ErrorBoundary';
import "./i18n";

// Suppress known library warnings in development
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    // Suppress react-modal-video's legacy context API warning
    if (
      typeof args[0] === 'string' &&
      args[0].includes('Legacy context API')
    ) {
      return;
    }
    // Suppress unsafe lifecycle warnings from react-modal-video
    if (
      typeof args[0] === 'string' &&
      args[0].includes('UNSAFE_componentWillMount')
    ) {
      return;
    }
    originalError.call(console, ...args);
  };
}

ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);

//document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
